// Imports for external libraries go here.
import clsx from 'clsx';
import { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { Button } from '@marriott/mi-ui-library';
import { NavigationDropdownProps } from '../NavigationDropdown.types';
import { StyledNavigationDropdown, StyledNavigationDropdownItem } from './NavigationDropdownDesktop.styles';

const NavigationDropdownDesktop: FC<NavigationDropdownProps> = ({
  menuItemLabel,
  ariaLabel,
  sectionNavigationSubItems,
  activeMenuItem,
  trackingProperties,
  menuItemIndex,
}) => {
  return (
    <StyledNavigationDropdown className="sub-menu" aria-label={ariaLabel}>
      {sectionNavigationSubItems.map((subMenuItem, subMenuItemIndex) => (
        <StyledNavigationDropdownItem
          id={`sub_menu_item_${menuItemIndex}${subMenuItemIndex}`}
          key={`sub-menu-item-${menuItemIndex}${subMenuItemIndex}`}
          className={clsx(
            menuItemLabel === activeMenuItem?.menuLabel &&
              subMenuItem.subMenuItemLabel === activeMenuItem?.subMenuLabel &&
              'selected'
          )}
        >
          <Button
            isLink
            className="sub-menu-item"
            href={subMenuItem.subMenuItemPath}
            aria-expanded="false"
            aria-controls={`sub_menu_item_${menuItemIndex}${subMenuItemIndex}`}
            custom_click_track_value={`${menuItemLabel} | ${subMenuItem.subMenuItemLabel} |internal`}
            trackingProperties={trackingProperties}
            target={subMenuItem?.openInNewTab ? '_blank' : '_self'}
            ariaLabel={subMenuItem.subMenuItemLabel}
          >
            {subMenuItem.subMenuItemLabel}
          </Button>
        </StyledNavigationDropdownItem>
      ))}
    </StyledNavigationDropdown>
  );
};

export default NavigationDropdownDesktop;
